import { Alert, Button, CopyButton, downloadText } from "@nabble/ui";

export function RecoveryCodesPanel({ codes }: { codes: string[] }): React.JSX.Element {
  const text = `Nabble Suite — recovery codes\nEach code can be used only once.\n\n${codes.join("\n")}\n`;
  return (
    <div className="nb-stack">
      <ol className="nb-codes" aria-label="Recovery codes">
        {codes.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ol>
      <div className="nb-row">
        <CopyButton value={codes.join("\n")} label="Copy codes" />
        <Button
          label="Download .txt"
          variant="secondary"
          icon="download"
          onClick={() => downloadText("nabble-recovery-codes.txt", text)}
        />
      </div>
      <Alert tone="warning">Each code can be used only once. Keep them somewhere safe, like your password manager.</Alert>
    </div>
  );
}
